import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect, lazy, Suspense } from "react";
import React from "react";
import ScrollToTop from "./components/ScrollToTop";
import RedirectHandler from "./components/RedirectHandler";
import CookieBanner from "./components/CookieBanner";
import LocaleManager from "./components/LocaleManager";
import ChatWidget from "./components/ChatWidget";
import { ConfigModalProvider } from "./components/ConfigModal";
import { trackPageview } from "./lib/analytics";
import Home from "./pages/Home";
const PartnerPage = lazy(() => import("./pages/PartnerPage"));
const BozzaSchede = lazy(() => import("./pages/BozzaSchede"));
const BozzaAiVesta = lazy(() => import("./pages/BozzaAiVesta"));
const BozzaMonitoring = lazy(() => import("./pages/BozzaMonitoring"));
const Azienda = lazy(() => import("./pages/Azienda"));
const Tecnologia = lazy(() => import("./pages/Tecnologia"));
const Prodotti = lazy(() => import("./pages/Prodotti"));
const ProdottoCategoria = lazy(() => import("./pages/ProdottoCategoria"));
const Prodotto = lazy(() => import("./pages/Prodotto"));
const ChiaviInMano = lazy(() => import("./pages/ChiaviInMano"));
const Installatori = lazy(() => import("./pages/Installatori"));
const News = lazy(() => import("./pages/News"));
const NewsArticolo = lazy(() => import("./pages/NewsArticolo"));
const Legal = lazy(() => import("./pages/Legal"));
const Contatti = lazy(() => import("./pages/Contatti"));
const Admin = lazy(() => import("./pages/Admin"));
const AreaClienti = lazy(() => import("./pages/AreaClienti"));
const RichiediGaranzia = lazy(() => import("./pages/RichiediGaranzia"));
const GaranziaPratica = lazy(() => import("./pages/GaranziaPratica"));
import NotFound from "./pages/NotFound";
const SeoPage = lazy(() => import("./pages/SeoPage"));
const PannelliItaliani = lazy(() => import("./pages/PannelliItaliani"));
const FotovoltaicoTetto = lazy(() => import("./pages/FotovoltaicoTetto"));
const ProduzioneMadeInItaly = lazy(() => import("./pages/ProduzioneMadeInItaly"));
const PaymentResult = lazy(() => import("./pages/PaymentResult"));

function AnalyticsTracker() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    const t = setTimeout(trackPageview, 350); // attende l'aggiornamento del title
    return () => clearTimeout(t);
  }, [pathname, search]);
  return null;
}

function GlobalChat() {
  const { pathname } = useLocation();
  const hidden = pathname.startsWith("/admin") || pathname.startsWith("/area-clienti");
  if (hidden) return null;
  return <ChatWidget />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <AnalyticsTracker />
        <ConfigModalProvider>
        <RedirectHandler>
        <LocaleManager>
        <Suspense fallback={<div className="bg-black min-h-screen" />}>
        <Routes>
          {/* Pagine pubbliche multilingua: IT alla radice, EN su /en, DE su /de, FR su /fr */}
          {["", "en/", "de/", "fr/"].map((p) => (
            <React.Fragment key={p || "it"}>
              <Route path={`/${p}`} element={<Home />} />
              <Route path={`/${p}azienda`} element={<Azienda />} />
              <Route path={`/${p}tecnologia`} element={<Tecnologia />} />
              <Route path={`/${p}prodotti`} element={<Prodotti />} />
              <Route path={`/${p}prodotti/:categoria`} element={<ProdottoCategoria />} />
              <Route path={`/${p}prodotto/:slug`} element={<Prodotto />} />
              <Route path={`/${p}chiavi-in-mano`} element={<ChiaviInMano />} />
              <Route path={`/${p}installatori`} element={<Installatori />} />
              <Route path={`/${p}news`} element={<News />} />
              <Route path={`/${p}news/:id`} element={<NewsArticolo />} />
              <Route path={`/${p}legali/:slug`} element={<Legal />} />
              <Route path={`/${p}contatti`} element={<Contatti />} />
              <Route path={`/${p}:partnerSlug`} element={<PartnerPage />} />
            </React.Fragment>
          ))}
          {/* Solo italiano (auth / admin / garanzie) */}
          <Route path="/bozza-schede" element={<BozzaSchede />} />
          <Route path="/bozza-ai-vesta" element={<BozzaAiVesta />} />
          <Route path="/bozza-monitoring" element={<BozzaMonitoring />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/area-clienti" element={<AreaClienti />} />
          <Route path="/assistenza/garanzia" element={<RichiediGaranzia />} />
          <Route path="/fotovoltaico/*" element={<SeoPage />} />
          <Route path="/pannelli-fotovoltaici-italiani" element={<PannelliItaliani />} />
          <Route path="/fotovoltaico-tetto" element={<FotovoltaicoTetto />} />
          <Route path="/produzione-di-pannelli-fotovoltaici-made-in-italy" element={<ProduzioneMadeInItaly />} />
          <Route path="/payment/success" element={<PaymentResult outcome="success" />} />
          <Route path="/payment/cancel" element={<PaymentResult outcome="cancel" />} />
          <Route path="/garanzia/:token" element={<GaranziaPratica />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        </Suspense>
        </LocaleManager>
        </RedirectHandler>
        </ConfigModalProvider>
        <GlobalChat />
        <CookieBanner />
      </BrowserRouter>
    </div>
  );
}

export default App;
